import {useTranslation} from "react-i18next";
import {AddBox} from "@material-ui/icons";
import React from "react";
import styled from "styled-components/macro";
import {
  CardContent as MuiCardContent,
  Card as MuiCard,
  Typography as MuiTypography,} from "@material-ui/core";
import {spacing} from "@material-ui/system";

const Typography = styled(MuiTypography)(spacing)

const CardContent = styled(MuiCardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

let NewCompanyCard = styled(MuiCard)(spacing)
NewCompanyCard = styled(MuiCard)`
  background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
  width:100%;
`

type NewPropertyCreateType = {
  handleClick: () => void
}

const CreateNewCompany = ({ handleClick }: NewPropertyCreateType) => {
  const { t } = useTranslation();
  return (
    <NewCompanyCard mb={6} onClick={() => { handleClick() }}>
      <CardContent>
        <AddBox style={{ color: 'black', width: "35px", height: "35px" }} />
        <Typography variant="h6" style={{ color: 'black', width: "100%", textAlign: "center" }} mt={1}>
          Create new company
        </Typography>
      </CardContent>
    </ NewCompanyCard>
  );
}

export default CreateNewCompany